import { SvgIcon } from 'ui/icons/SvgIcon';
import { TEST_IDS } from '../constants';

export const StrengthMeterWeakSvg = ({ height = 24, width = 24 }) => (
  <SvgIcon height={height} width={width} data-test={`${TEST_IDS.StrengthMeterWeak}`}>
    <rect x="6" y="9.5" width="2.5" height="7" rx="1.25" fill="#8DDFF8" />
    <rect x="10" y="7.5" width="2.5" height="9" rx="1.25" fill="#F5F4F4" />
    <rect x="14" y="5.5" width="2.5" height="11" rx="1.25" fill="#F5F4F4" />
  </SvgIcon>
);

export const StrengthMeterSatisfactorySvg = ({ height = 24, width = 24 }) => (
  <SvgIcon height={height} width={width} data-test={`${TEST_IDS.StrengthMeterSatisfactory}`}>
    <rect x="6" y="9.5" width="2.5" height="7" rx="1.25" fill="#34C3F2" />
    <rect x="10" y="7.5" width="2.5" height="9" rx="1.25" fill="#34C3F2" />
    <rect x="14" y="5.5" width="2.5" height="11" rx="1.25" fill="#F5F4F4" />
  </SvgIcon>
);

export const StrengthMeterStrongSvg = ({ height = 24, width = 24 }) => (
  <SvgIcon height={height} width={width} data-test={`${TEST_IDS.StrengthMeterStrong}`}>
    <rect x="6" y="9.5" width="2.5" height="7" rx="1.25" fill="#2489A9" />
    <rect x="10" y="7.5" width="2.5" height="9" rx="1.25" fill="#2489A9" />
    <rect x="14" y="5.5" width="2.5" height="11" rx="1.25" fill="#2489A9" />
  </SvgIcon>
);
